import axios from 'axios'
import classNames from 'classnames'
import React, { useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import { Link, useHistory } from 'react-router-dom'
import { InputForm } from '../../../components/Input'
import { regExEmail } from '../../../components/RegEx'
import { patternEmail, patternMinLength, Required } from '../../../components/RegEx/ValidationMessage'
import http from '../../../config/BaseUrl'
import '../style/style.css'
import Logo from '../../../assets/images/logo/Haylo-logo-white.png'
import RegisterImage from '../../../assets/images/register.jpg'


const RegisterUser = () => {
  const history = useHistory()
  const [userType, setUserType] = useState("individual")
  const [loading, setLoading] = useState(false)
  const [businessCategory, setBusinessCategory] = useState("")
  const { register, handleSubmit, watch, setError, formState: { errors } } = useForm({ mode: "all", reValidateMode: "all" })
  const password = useRef({});
  password.current = watch("password", "");
  
  const handelRegister = async (data) => {
    try {
      setLoading(true)
      await http.post('register', data).then((res) => {
        let user_info = res.data.user;
        if (res.data.access_token) {
          history.push('/resend/email', { id: user_info.id, email: user_info.email })
          setLoading(false)
        }
      }).catch((err) => {
        const errorNames = Object.keys(err.response.data.errors);
        const errorMessages = Object.values(err.response.data.errors);
        errorNames.forEach((err, indx) => {
          setError(err, { type: 'required', message: errorMessages[indx][0] })
        })
        setLoading(false)
      })
    } catch (error) {
      setLoading(false)
    }
  }

  return (
    <>

      <div className="p-3 section-authentication-login p-md-0">
        <div className="px-0 container-fluid">

          <div className="row h-100">
            <div className="col-md-6 d-none d-md-block">
              <div className="page-image">
                <div className="login-header mt-5">
                  <div className="logo">
                    <img src={Logo} className="img-fluid" alt="haylo" />
                  </div>

                </div>
                <div className="image-body">
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="form-body">
                <div className="row justify-content-center align-items-center h-100">
                  <div className="col-md-8 col-lg-7 col-sm-8 col-12">
                    <div className="mx-auto my-auto h-100">
                      <div className="p-md-3">
                        <div className="text-left">
                          <h3 className="font-weight-bold">Sign up to The Haylo</h3>
                        </div>
                        <hr />
                        <form onSubmit={handleSubmit(handelRegister)}>

                          <div className="form-group">
                            <div className="custom-control custom-radio custom-control-inline">
                              <input
                                type="radio"
                                name="user_type"
                                id="Individual"
                                className="custom-control-input"
                                value="individual"
                                {...register("user_type")}
                                onChange={(e) => setUserType(e.target.value)}
                                checked={userType === "individual" ? true : false}
                              />
                              <label className="custom-control-label" htmlFor="Individual">Individual </label>
                            </div>
                            <div className="custom-control custom-radio custom-control-inline">
                              <input
                                type="radio"
                                name="user_type"
                                id="Business"
                                className="custom-control-input"
                                value="business"
                                {...register("user_type")}
                                onChange={(e) => setUserType(e.target.value)}
                                checked={userType === "business" ? true : false}
                              />
                              <label className="custom-control-label" htmlFor="Business">Business</label>
                            </div>
                          </div>

                          {userType === "individual" ? (<>
                            <div className={`form-group ${userType === "individual" ? "d-block" : "d-none"}`}>
                              <input
                                label="First Name"
                                text="text"
                                name="first_name"
                                placeholder="First Name"
                                {...register("first_name")}
                                className={`form-control mb-2 `} 
                              />
                            </div>

                            <div className={`form-group ${userType === "individual" ? "d-block" : "d-none"}`}>
                              <input
                                label="Last Name"
                                text="text"
                                name="last_name"
                                placeholder="Last Name"
                                className={`form-control mb-2 `} 
                                {...register("last_name")}
                              />
                            </div>
                          </>) : ""}

                          {userType === "business" ? (<>

                            <div className={`form-group ${userType === "business" ? "d-block" : "d-none"}`}>
                              <select
                                className={classNames("form-control", { "is-invalid": errors.business_category })}
                                name="business_category"
                                {...register("business_category", {
                                  required: Required
                                })}
                                value={businessCategory}
                                onChange={(e) => setBusinessCategory(e.target.value)}
                              >
                                <option value="">Select Category</option>
                                <option value="bar">Bar</option>
                                <option value="pub">Pub</option>
                                <option value="nightclub">Nightclub</option>
                                <option value="function-room">Function Room</option>
                                <option value="restaurant">Restaurant</option>
                                <option value="cafe">Cafe</option>
                                <option value="retail-store">Retail Store</option>
                                <option value="other">Other</option>
                              </select>
                            </div>

                            {businessCategory === "other" ?
                              (<><div className="form-group">
                                <input
                                  label="Other"
                                  type="text"
                                  name="business_category_other"
                                  placeholder="Other"
                                  {...register("business_category_other")}
                                />
                              </div></>) : ""
                            }

                            <div className={`form-group ${userType === "business" ? "d-block" : "d-none"}`}>
                              <input
                                label="Company name"
                                text="text"
                                name="company_name"
                                placeholder="Company Name"
                                // isError={errors.company_name}
                                className={`form-control mb-2 ${errors.company_name ? 'is-invalid' : ''}`} 
                                {...register("company_name", { required: Required })}
                              />
                            </div>

                          </>) : ""}



                          <div className="form-group">
                            <input
                              label="Email Address"
                              type="email"
                              name="email"
                              placeholder="Enter your email address"
                              // isError={errors.email}
                              className={`form-control mb-2 ${errors.email ? 'is-invalid' : ''}`} 
                              {...register("email", { required: Required, pattern: { value: regExEmail, message: patternEmail } })}
                            />
                          </div>

                          <div className="form-group">
                            <input
                              label="Password"
                              type="password"
                              name="password"
                              placeholder="Enter your password"
                              // isError={errors.password}
                              className={`form-control mb-2 ${errors.password ? 'is-invalid' : ''}`} 
                              {...register("password", { required: Required, minLength: { value: 6, message: patternMinLength(6) } })}
                            />
                          </div>

                          <div className="form-group">
                            <input
                              label="Re-type your Password"
                              type="password"
                              name="password_confirmation"
                              placeholder="Re-type your Password"
                              // isError={errors.password_confirmation}
                              className={`form-control mb-2 ${errors.password_confirmation ? 'is-invalid' : ''}`} 
                              {...register("password_confirmation", {
                                validate: value =>
                                  value === password.current || "The passwords do not match"
                              })}
                            />
                          </div>

                          <div className="form-group">
                            <label class="custom-checkbox">
                              <small className="text-secondary">
                                Create an account means you're okay with our <Link to="https://thehaylo.com.au/terms-conditions/">Terms of Service</Link> and <Link to="https://thehaylo.com.au/privacy-policy/">Privacy Policy</Link>
                              </small>
                              <input type="checkbox"
                                name="check_promotion"
                                {...register("check_promotion", {
                                  required: true
                                })} />
                              <span class="custom-checkmark"></span>
                            </label>
                            <span className="error-message text-danger d-block font-size-14">
                              {errors.check_promotion && "Please check the agreement."}
                            </span>
                          </div>

                          <div className="mt-3 btn-group w-100">
                            <button type="submit" className="px-5 m-1 btn btn-primary radius-30 btn-block">
                              {loading && loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>)
                                : ("Register")
                              }
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <p className="pr-5 text-right font-weight-bold">Already have an account? <Link to="/">Back to login</Link></p>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>

      </div>

    </>
  )
}

export default RegisterUser
